export default __webpack_public_path__ + "static/media/bsc.24b1e0ef.svg";